import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    endTime?: ?string;
}

export class TimesheetEntryEndTime extends React.PureComponent<Props> {
    render() {
        const { endTime } = this.props;
        if (!endTime) return null;
        return moment(endTime, 'HH:mm:ss').format('h:mm a');
    }
}

const mapStateToProps = createStructuredSelector({
    endTime: makeSelectTimesheetEntryValue('endTime')
});

export default connect(mapStateToProps)(TimesheetEntryEndTime);
